// i18next configuration — local-file translations.
//
// Translations live in `src/locales/{fr,en}.json` and are bundled with the
// app. No network fetch on boot, no separate translation API, no DB
// round-trip. Updating copy = edit the JSON + ship a deploy.
//
// Don't switch back to fetching `/Translation?lang={lng}` from the
// backend — that endpoint double-encodes and produces mojibake in French
// strings (`RÃ©cents` for `Récents` etc.). The local files are the
// cleaned-up source of truth.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import customDetector from "./customDetector";
import fr from "../locales/fr.json";
import en from "../locales/en.json";

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customDetector);

// Add names for each locale to show the user in our locale switcher.
export const supportedLngs = {
  fr: "Français",
  en: "English",
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    supportedLngs: Object.keys(supportedLngs),
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "production" ? false : true,

    // Normally `escapeValue: true` is the safe default, but React already
    // escapes interpolations so we keep it off here. Prefix/suffix are
    // single-brace (`{0}`, `{name}`) to match the backend dump's existing
    // placeholders (e.g. "REG. PRICE ~{0}" in Price_Drop_Title).
    interpolation: {
      escapeValue: false,
      prefix: "{",
      suffix: "}",
    },
  });

export default i18n;
